'use strict';

/* global $ */


import { interfaceName } from './settings';
import { fancybox } from 'settings';

import { Ajax } from './utils/ajax';

import { AjaxForm } from './modules/ajax-form';
import { AjaxGallery } from './modules/ajax-gallery';
import { AjaxNews } from './modules/ajax-news';
import { AjaxQuestions } from './modules/ajax-questions';
import { AjaxReviews } from './modules/ajax-reviews';
import { Contacts } from './modules/contacts';
import { ContactsMap } from './modules/contacts-map';
import { DoctorsSlider } from './modules/doctors-slider';
import { FoldingReviews } from './modules/folding-reviews';
import { Gallery } from './modules/gallery';
import { Goal } from './modules/goal';
import { NiceScroll } from './modules/nicescroll';
import { PriceList } from './modules/price-list';
import { Responsive } from './modules/responsive';
import { ScrollTo } from './modules/scroll-to';
import { Search } from './modules/search';
import { Slider } from './modules/slider';
import { SliderMobile } from './modules/slider-mobile';
import { MainMenu } from './modules/main-menu';
import { StickyMenu } from './modules/sticky-menu';
import { ToggleContent } from './modules/toggle-content';
import { ToggleMenu } from './modules/toggle-menu';
import { TogglePhones } from './modules/toggle-phones';

class Proj {
    constructor() {
        this.init();
    }
    init() {
        this.interfaceName = interfaceName;

        this.toggleMenu = new ToggleMenu();
        this.togglePhones = new TogglePhones();
        this.mainMenu = new MainMenu();
        this.stickyMenu = new StickyMenu();
        this.niceScroll = new NiceScroll();
        this.search = new Search();
        this.scrollTo = new ScrollTo();
        this.ajaxForm = new AjaxForm();

        if (interfaceName == 'home_page' || interfaceName == 'price_cat' || interfaceName == 'service_cat' || interfaceName == 'news' || interfaceName == 'service_group' || interfaceName == 'service') {
            this.slider = new Slider();
            this.sliderMobile = new SliderMobile();
        }

        if (interfaceName == 'page_with_reviews') {
            this.ajaxReviews = new AjaxReviews();
            this.foldingReviews = new FoldingReviews();
        }

        if (interfaceName == 'doctor' || interfaceName == 'service_cat' || interfaceName == 'service') {
            this.foldingReviews = new FoldingReviews();
        }

        if (interfaceName == 'page_with_form_questions') {
            this.ajaxQuestions = new AjaxQuestions();
        }

        if (interfaceName == 'price_cat' || interfaceName == 'service_cat' || interfaceName == 'service_group' || interfaceName == 'service') {
            this.priceList = new PriceList();
            this.toggleContent = new ToggleContent();
        }

        if (interfaceName == 'service_cat' || interfaceName == 'page_cat' || interfaceName == 'doctor' || interfaceName == 'news' || interfaceName == 'page' || interfaceName == 'page_with_form') {
            this.gallery = new Gallery();
        }

        if (interfaceName == 'news_cat') {
            this.ajaxNews = new AjaxNews();
        }

        if (interfaceName == 'doctors_cat' || interfaceName == 'service_cat' || interfaceName == 'service_group'  || interfaceName == 'service') {
            this.doctorsSlider = new DoctorsSlider();
        }

        if (interfaceName == 'page_with_form') {
            this.contacts = new Contacts();
            this.contactsMap = new ContactsMap();
            this.ajaxGallery = new AjaxGallery();
        }

        // ===========================================================

        let $toTop = $('<span class="scroll-to-top js-to-top"></span>').appendTo(document.body);

        $(window).on('scroll', function() {
            if ($(window).scrollTop() >= 100) {
                $toTop.show();
            } else {
                $toTop.hide();
            }
        }).trigger('scroll');

        $('.js-to-top').on('click', function(e) {
            $('html, body').animate({
                scrollTop: 0 
            }, 1000);
        });

        $('[data-fancybox]').fancybox({
            thumbs : {
                autoStart : true,
                axis: 'x'
            },
            transitionEffect: 'zoom-in-out',
            backFocus: false,
            lang: 'ru',
            i18n: {
                ru: {
                    CLOSE: 'Закрыть',
                    NEXT: 'Следующий',
                    PREV: 'Предыдущий',
                    ERROR: "Запрашиваемый контент не может быть загружен.<br/>Попробуйте позже.",
                    PLAY_START: 'Запустить слайдшоу',
                    PLAY_STOP: 'Остановить слайдшоу',
                    FULL_SCREEN: 'На весь экран',
                    THUMBS: 'Галерея превью',
                    DOWNLOAD: 'Скачать',
                    SHARE: 'Поделиться',
                    ZOOM: 'Увеличить'
                },
            },
            video: {
                tpl:
                  '<video class="fancybox-video" loop muted autuplay controlsList="nodownload" poster="{{poster}}">' +
                  '<source src="{{src}}" type="{{format}}" />' +
                  'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
                  "</video>",
                format: "",
                autoStart: true
            },
        });

		if ($('body').data('popup')) {
			console.log('[ Popup/init ]');
			let object_id = $('body').data('popup');
			let delay = $('body').data('delay');
			setTimeout(function() {
                Ajax.get('get_popup', { object_id: object_id }).then((data) => {
                    console.log('Popup/get/then', data);
                    if (data.ok) {
				        $.fancybox.open({
				            type: 'html',
				            src: data.content,
				            touch: false,
				            afterShow: function(instance, current) {
				            }
				        });
                    }
                });

			}, delay * 1000);
		}

        // ===========================================================

        this.goal = new Goal({
            goals: [
                {
                    selector: '.js-goal__link',
                    event: 'click',
                    handler: function() {
                        $(window).trigger('main:reachGoal', $(this).data());
                    }
                }, {
                    selector: '.js-goal__form',
                    event: 'submit',
                    handler: function() {
                        $(window).trigger('main:reachGoal', $(this).data());
                    }
                }, {
                    selector: window,
                    event: 'goal ajaxForm:goal',
                    handler: function(e, data) {
                        $(window).trigger('main:reachGoal', data);
                    }
                }
            ]
        });

        this.responsive = new Responsive();
    }
}

$(function() {
    window.proj = new Proj();
});
